export const isNameValid = (text) => /^[a-zA-Z\s]*$/.test(text);
export const isPriceValid = (value) => /^\d+(\.\d{1,2})?$/.test(value);
export const isDescriptionValid = (text) => /^[A-Za-z0-9áéíóúÁÉÍÓÚñÑ,.\-_\s]*$/.test(text);